import { Trans } from "react-i18next"

import util from "utils/utils"

export default function IdeaSubmittedContent({ events, ownerChallenge = { name: "Deleted" } }) {
  return (
    <Trans i18nKey="notifications.ideaSubmitted">
      <b>{{ name: util.getEventNames(events) }}</b>
      submitted the idea
      {events.length > 1 ? "s" : ""}
      <b>
        {{
          idea: `${events.map((e, index) => {
            let name = index < events.length && index !== 0 ? " " : ""
            name += e.ownerIdea.name || "[Deleted]"
            return name
          })}`,
        }}
      </b>
      to your challenge
      <b>{{ challenge: ownerChallenge.name || "Deleted" }}</b>
    </Trans>
  )
}
